import alertsDismissed from './cookie/alertsDismissed';
import cookieBasedFeatureToggles from './cookie/cookieBasedFeatureToggles';
import hybrisRoute from './cookie/hybrisRoute';
import loop54UserSession from './cookie/loop54UserSession';
import recipeRatings from './cookie/recipeRatings';
import storeContext from './cookie/storeContext';
import abTestStorage from './localStorage/abTestStorage';
import ecommerceSections from './localStorage/ecommerceSections';
import priceTypeStorage from './localStorage/priceTypeStorage';
import temporaryAddressSession from './sessionStorage/addressSession';
import bonusBannerStorage from './sessionStorage/bonusBannerStorage';
import { coopDevToolsSession } from './sessionStorage/coopDevToolsSession';
import customerGroupsSession from './sessionStorage/customerGroupsSession';
import hybrisUserInfoSession from './sessionStorage/hybrisUserInfoSession';
import userProfileSession from './sessionStorage/userProfileSession';

const persistance = {
    ecommerceSections,
    priceTypeStorage,
    bonusBannerStorage,
    abTestStorage,
    customerGroupsSession,
    alertsDismissed,
    recipeRatings,
    storeContext,
    coopDevToolsSession,
    hybrisRoute,
    temporaryAddressSession,
    userProfileSession,
    hybrisUserInfoSession,
    loop54UserSession,
    cookieBasedFeatureToggles,
};

export default persistance;
